import { render, staticRenderFns } from "./main.vue?vue&type=template&id=cd9830c4&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=cd9830c4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9830c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd9830c4')) {
      api.createRecord('cd9830c4', component.options)
    } else {
      api.reload('cd9830c4', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=cd9830c4&scoped=true", function () {
      api.rerender('cd9830c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/printer/main.vue"
export default component.exports